// extracted by mini-css-extract-plugin
export var socialLinks = "social-links-module--social-links--LaWln";